import Phaser from 'phaser';
import GameScene from './scenes/GameScene';

// Create temporary scene to get dimensions
const tempScene = new GameScene();

// Game configuration
const config = {
    type: Phaser.WEBGL,
    width: tempScene.totalWidth,
    height: tempScene.totalHeight,
    backgroundColor: '#c2c8cd',
    parent: 'game-container',
    scene: [GameScene],
    scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        width: tempScene.totalWidth,
        height: tempScene.totalHeight,
        parent: 'game-container',
        expandParent: false,
    },
    render: {
        antialias: true,
        pixelArt: false,
        roundPixels: false
    },
    dom: {
        createContainer: false
    },
    autoRound: false
};

// Initialize game
const game = new Phaser.Game(config);

// Remove any inline styles Phaser might have added
const container = document.getElementById('game-container');
if (container) {
    container.removeAttribute('style');
}

// Set canvas rendering to high quality
game.canvas.style.imageRendering = 'auto';
game.canvas.style.imageSmoothingEnabled = 'true';
game.canvas.style.imageSmoothingQuality = 'high';

// Handle high DPI displays
const scale = window.devicePixelRatio || 1;
game.canvas.width = game.canvas.width * scale;
game.canvas.height = game.canvas.height * scale;
game.canvas.style.width = game.canvas.width / scale + 'px';
game.canvas.style.height = game.canvas.height / scale + 'px';
